export default function Style(theme) {
    const style = {
        root: {
          display: 'block',
          margin: '0 auto',
          '& > * + *': {
            marginLeft: 16,
          },
        },
        circularProgress: {
            margin: "0 auto",
            display: 'block'
        }
      }
      return style
  }